import { fieldToTextField, TextFieldProps } from 'formik-mui';
import React, { FC } from 'react';
import { TextField } from '@mui/material';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const OvSelectFormControl: FC<TextFieldProps> = ({ children, ...props }) => {
  const {
    form: { setFieldValue },
    field: { name },
  } = props;
  const onChange = React.useCallback(
    (event: any) => {
      const { value } = event.target;
      setFieldValue(name, value);
    },
    [setFieldValue, name]
  );

  return (
    <StyledTextField {...fieldToTextField(props)} select onChange={onChange}>
      {children}
    </StyledTextField>
  );
};

const StyledTextField = styled(TextField)`
  && {
    background: ${Colours.WHITE};
    border-radius: ${Variables.borderRadius.SMALL};
    & label.Mui-focused {
      color: ${Colours.OV_BASE};
    }

    & label.Mui-error {
      color: ${Colours.OV_RED};
    }

    & .MuiOutlinedInput-root {
      & fieldset {
        border-color: ${Colours.OV_BASE};
      }

      &.Mui-error fieldset,
      &.Mui-error:hover fieldset,
      &.Mui-error.Mui-focused {
        border-color: ${Colours.OV_RED};
      }

      &:hover fieldset {
        border-color: ${Colours.OV_DARK_BLUE};
      }

      & input {
        color: ${Colours.OV_BASE};
        padding: 14px 10px;
        font-size: ${Variables.fontSizes.MEDIUM};

        &:autofill {
          box-shadow: 0 0 0 50px white inset;
          -webkit-text-fill-color: ${Colours.OV_BASE};

          &:focus {
            box-shadow: 0 0 0 50px white inset;
            -webkit-text-fill-color: ${Colours.OV_BASE};
          }
        }
      }

      & label {
        line-height: normal;
      }
    }
  }
`;

export default OvSelectFormControl;
